import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFloppyDisk1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"floppy-disk-1, save"} maskId="square-filled-radius-0-stroke-1-IconFloppyDisk1"><path d="M17 3H17.7071L21 6.29289V21H17V12H7V21H3V3H7V9H17V3Z" fill="currentColor"/><path d="M16 3H8V8H16V3Z" fill="currentColor"/><path d="M8 21H16V13H8V21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFloppyDisk1;
